var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('th'),_c('th'),_c('th'),_vm._m(0),_c('th'),_c('th'),_c('td',{staticClass:"text-center"},[_c('div',[_vm._v("\n      "+_vm._s(_vm.totalCommissionPaid + " ฿")+"\n    ")])]),_c('th'),_c('th')])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('th',{staticClass:"text-center"},[_c('div',[_c('b',[_vm._v("Total Paid Commission")])])])
}]

export { render, staticRenderFns }